function DeliveryInfo() {
  return (
    <div className="container-lg mt-4">

      {/* --- Szállítás --- */}
      <h4 className="mb-2">Szállítás</h4>
      <hr className="my-0 mb-3" />

      {/* --- Személyes átvétel --- */}
      <h5>Személyes átvétel</h5>
      <p>
        <span className="d-block mt-1">
          <strong>FONTOS!</strong> Ellenőrizd a készletet: A termék adatlapján minden esetben ellenőrizd az adott bolt raktárkészletét. Ha a termék online elérhető, akkor a rendelésed személyesen, üzletünkben is átvehető.
        </span>
      </p>

      <ul>
        <li><strong>Átvételi hely:</strong> 7800 Nagytótfalu, Rákóczi u. 14/c</li>
        <li><strong>Nyitvatartási idő:</strong> H-P: 8.00-16.00, Sz: 8.00-12.00, V: Zárva</li>
      </ul>

      {/* --- FOXPOST --- */}
      <h5 className="mt-4">FOXPOST – Packeta Group automaták és átvevőhelyek</h5>
      <p className="mb-1">
        Válaszd ki a számodra legkényelmesebb átvételi pontot!
        A raktáron lévő termékeket a FOXPOST <strong>1–2 munkanap</strong> alatt eljuttatja az automatába vagy az átvételi pontra.
      </p>
      <p>
        Értesítést e-mailben és Viberen vagy SMS-ben kapsz, benne az egyedi átvételi kóddal.
        A csomag <strong>4 napig</strong> vehető át.
      </p>

      {/* --- Posta Pont --- */}
      <h5 className="mt-4">Posta Pont / Csomagautomata</h5>
      <p className="mb-1">Rendelését kérheti:</p>
      <ul>
        <li>posta mellett</li>
        <li>MOL kútra</li>
        <li>Coop Postapontra</li>
        <li>csomagautomatába országszerte</li>
      </ul>
      <p>
        A Magyar Posta a saját készleten levő termékeinket <strong>2–5 munkanapon</strong> belül szállítja ki a megadott Posta Pontra.
      </p>

      {/* --- MPL Házhozszállítás --- */}
      <h5 className="mt-4">MPL Házhozszállítás</h5>
      <p>
        Rendelését a Magyar Posta szállítja ki az Ön által megadott címre <strong>2–5 munkanap</strong> alatt.
      </p>

      {/* --- Fizetés --- */}
      <h4 className="mb-2 mt-4">Fizetés</h4>
      <hr className="my-0 mb-3" />

      <h5>Fizetési módok</h5>
      <ul>
        <li>
          <strong>Helyszíni fizetés:</strong> Személyes átvétel esetén üzletünkben a termék ellenértékét készpénzzel vagy bankkártyával tudja kifizetni.
        </li>
        <li>
          <strong>Bankkártyás fizetés:</strong> Az oldalon a <em>Stripe</em> szolgáltatón keresztül történik a bankkártyás fizetés lebonyolítása.
        </li>
      </ul>
    </div>
  );
}

export default DeliveryInfo;
